import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Heart, Gift, Sparkles, Home } from 'lucide-react';

const ThankYouDonation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Activate donation bonus
    const bonusData = {
      timestamp: Date.now(),
      dailyLimit: 20,
      daysRemaining: 3
    };
    localStorage.setItem('donation_bonus', JSON.stringify(bonusData));
    
    // Also log it for debugging
    console.log('Donation bonus activated:', bonusData);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Header with gradient */}
          <div className="bg-gradient-to-r from-rose-500 to-pink-600 p-8 text-center">
            <div className="inline-block p-4 bg-white rounded-full mb-4">
              <Heart className="h-12 w-12 text-rose-500" />
            </div>
            <h1 className="text-4xl font-bold text-white mb-2">
              Thank You for Your Donation! 🎉
            </h1>
            <p className="text-rose-100 text-lg">
              Your generosity helps us keep TweePorter.ca free and accessible
            </p>
          </div>

          {/* Content */}
          <div className="p-8 space-y-6">
            {/* Surprise Gift Section */}
            <div className="bg-gradient-to-r from-amber-50 to-yellow-50 border-2 border-amber-200 rounded-xl p-6 text-center">
              <div className="inline-block p-3 bg-amber-100 rounded-full mb-3">
                <Gift className="h-8 w-8 text-amber-600" />
              </div>
              <h2 className="text-2xl font-bold text-amber-900 mb-3">
                Surprise Gift! 🎁
              </h2>
              <p className="text-amber-800 text-lg mb-2">
                As a token of our appreciation, your browser has been updated with:
              </p>
              <div className="bg-white rounded-lg p-4 mt-4 border border-amber-200">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <Sparkles className="h-5 w-5 text-amber-600" />
                  <span className="text-2xl font-bold text-amber-900">20 AI Generations/Day</span>
                  <Sparkles className="h-5 w-5 text-amber-600" />
                </div>
                <p className="text-amber-700 font-semibold">
                  Valid for the next 3 days!
                </p>
              </div>
            </div>

            {/* What This Means */}
            <div className="bg-slate-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-slate-900 mb-3">
                What does this mean?
              </h3>
              <ul className="space-y-2 text-slate-700">
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold">✓</span>
                  <span>Your daily AI story generation limit is now <strong>20 uses per day</strong> (up from 5)</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold">✓</span>
                  <span>This bonus is active for <strong>3 full days</strong> starting now</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold">✓</span>
                  <span>No sign-up required - it's tied to your browser</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold">✓</span>
                  <span>Create more stories, experiment freely!</span>
                </li>
              </ul>
            </div>

            {/* Your Impact */}
            <div className="bg-indigo-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-indigo-900 mb-3">
                Your Impact 💙
              </h3>
              <p className="text-indigo-700 leading-relaxed">
                Your donation helps us cover AI API costs, server expenses, and development time. 
                It allows us to keep TweePorter.ca free for students, educators, small businesses, 
                and creators worldwide. Thank you for being part of our community!
              </p>
            </div>

            {/* CTA Button */}
            <div className="text-center pt-4">
              <Button
                onClick={() => navigate('/compiler')}
                size="lg"
                className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white px-8 py-6 text-lg"
              >
                <Home className="h-5 w-5 mr-2" />
                Start Creating Stories
              </Button>
              <p className="text-sm text-slate-600 mt-3">
                Head back to the story compiler and use your new bonus!
              </p>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <p className="text-center text-slate-600 mt-6 text-sm">
          Questions? Email us at support@tweeporter.ca
        </p>
      </div>
    </div>
  );
};

export default ThankYouDonation;
